import { SummeetClient } from './SummeetClient';

const
	baseUri = '/api',
	apiInstance = new SummeetClient(baseUri);

export { apiInstance }
export * from './SummeetClient';
export * from './ITranscriptUtterance';
export * from './ITranscriptWord';
export * from './ITranscriptSpeaker';
export * from './TranscriptRequestOptions';